const EgyptIcon = () => {
  return (
    <svg
      id='egypt_2_'
      data-name='egypt (2)'
      xmlns='http://www.w3.org/2000/svg'
      width='23.62'
      height='16'
      viewBox='0 0 23.62 16'
    >
      <path
        id='Path_142255'
        data-name='Path 142255'
        d='M0,304.01v3.124a2.2,2.2,0,0,0,2.286,2.21H21.333a2.2,2.2,0,0,0,2.286-2.21V304.01Z'
        transform='translate(0 -293.343)'
        fill='#2e2f30'
      />
      <path
        id='Path_142256'
        data-name='Path 142256'
        d='M21.333,80.01H2.286A2.2,2.2,0,0,0,0,82.22v3.124H23.619V82.22A2.2,2.2,0,0,0,21.333,80.01Z'
        transform='translate(0 -80.01)'
        fill='#cc3434'
      />
      <rect
        id='Rectangle_7521'
        data-name='Rectangle 7521'
        width='23.619'
        height='5.333'
        transform='translate(0 5.333)'
        fill='#f5feff'
      />
      <path
        id='Path_142257'
        data-name='Path 142257'
        d='M321.448,309.343a2.27,2.27,0,0,0,2.362-2.21V304.01H315.2Z'
        transform='translate(-300.19 -293.343)'
      />
      <path
        id='Path_142258'
        data-name='Path 142258'
        d='M67.048,80.01H48l6.324,5.333h15.01V82.22A2.2,2.2,0,0,0,67.048,80.01Z'
        transform='translate(-45.714 -80.01)'
        fill='#ba2b2b'
      />
      <path
        id='Path_142259'
        data-name='Path 142259'
        d='M186.476,197.343h8.571V192.01H180Z'
        transform='translate(-171.429 -186.677)'
        fill='#d9e2e1'
      />
      <path
        id='Path_142260'
        data-name='Path 142260'
        d='M67.048,80.01H48l17.638,5.333h3.7V82.22A2.2,2.2,0,0,0,67.048,80.01Z'
        transform='translate(-45.714 -80.01)'
        fill='#a32323'
      />
      <path
        id='Path_142261'
        data-name='Path 142261'
        d='M418.286,193.077V192.01H414.4Z'
        transform='translate(-394.667 -186.677)'
        fill='#c9d3d1'
      />
      <path
        id='Path_142262'
        data-name='Path 142262'
        d='M23.619,368.048a2.17,2.17,0,0,1-2.286,2.248H2.286A2.268,2.268,0,0,1,0,368.01'
        transform='translate(0 -354.296)'
      />
      <g
        id='Group_26391'
        data-name='Group 26391'
        transform='translate(9.905 5.371)'
      >
        <path
          id='Path_142263'
          data-name='Path 142263'
          d='M211.81,197.305c-.038-.533-.038-1.067-.076-1.6a4.142,4.142,0,0,0-.038-.686,10.062,10.062,0,0,0-.076-1.1.316.316,0,0,0-.3-.114c-.3.038-.571.343-.876.3a1.219,1.219,0,0,1-.19-.5v-.3a.475.475,0,0,0-.152-.419.91.91,0,0,0-.343-.076c-.038,0-.076.038-.114.076-.152-.076-.381-.114-.343.114.152-.076.3.114.3.267a1.012,1.012,0,0,1-.229.8c-.343,0-.571-.267-.876-.3-.267-.038-.343.152-.343.419a4.61,4.61,0,0,1-.038.724,4.142,4.142,0,0,1-.038.686v.381c-.038.229,0,.533-.038.762a2.343,2.343,0,0,1-.038.533,1.828,1.828,0,0,1,.457,0c0,.038.038.038.038.114-.114.038-.114.114-.229.152.076.038.076.19.152.229,0,.076,0,.114.038.114.076.038.3.076.419.114a9.77,9.77,0,0,0,2.362-.038c.152-.038.229-.038.229-.19.076-.038.076-.152.152-.229a.526.526,0,0,1-.152-.114c-.038-.038-.038,0-.076-.038,0-.038,0-.076.038-.076A1.27,1.27,0,0,1,211.81,197.305Zm-3.2-.076c-.038.038-.076.038-.114.076-.038-.076.038-.152.114-.152Zm1.943.152a1.835,1.835,0,0,1-.457,0,.116.116,0,0,1,0-.152h.457c.19-.038.419-.076.571-.114.038,0,.038.076.038.114a1.608,1.608,0,0,1-.457.114C210.7,197.191,210.552,197.229,210.552,197.381Zm.152,0-.076.076a.118.118,0,0,0-.076-.038C210.552,197.267,210.7,197.229,210.7,197.381Zm-1.067-1.333c.038.038.076.076.114.076,0,.076-.038.152-.038.229C209.676,196.277,209.524,196.124,209.638,196.048Zm-.19.19a1.854,1.854,0,0,1-.038-.457l.229.229A1.01,1.01,0,0,1,209.448,196.239Zm.3.876c.038-.19.038-.419.076-.61a2.884,2.884,0,0,1-.038.571c0,.076.076.076.076.152l.114-.114c0-.19-.038-.419-.038-.61a2.941,2.941,0,0,1,.076.571c.038.038.076.038.076.076.038,0,.038-.038.076-.038.038.038,0,.076.038.114h-.152c-.038,0-.038.038-.076.038h-.229c-.038-.076-.152-.038-.229-.038,0-.038,0-.076.038-.076,0-.038.038.038.076.038C209.676,197.153,209.714,197.153,209.752,197.115Zm.61-.876c-.076-.038-.114-.152-.19-.229l.229-.229h0C210.4,195.934,210.362,196.086,210.362,196.239Zm.152-.686h0c.038.19.19.381.076.571-.076-.038-.114-.152-.19-.19A.644.644,0,0,1,210.514,195.553Zm-.3.571c-.038.076-.076.19-.114.267-.038-.076-.038-.152-.076-.229.038-.038.076-.038.114-.114A.082.082,0,0,1,210.21,196.124Zm-.381,1.371c-.038,0-.076-.038-.114-.076,0-.038.038-.038.038-.114C209.829,197.305,209.867,197.42,209.829,197.5Zm0-.19h.152c-.038.038-.038.114-.114.076C209.867,197.343,209.829,197.343,209.829,197.305Zm.19,0c.038,0,.038.076.076.114,0,.038-.076.038-.076.076C209.943,197.458,209.981,197.343,210.019,197.305Zm.457-.19c.038,0,.076.076.076.114h-.114C210.438,197.191,210.476,197.153,210.476,197.115Zm.19.076a.2.2,0,0,1,.076-.152c.038.038.076.076.076.114C210.781,197.153,210.7,197.191,210.667,197.191Zm.19-.038c-.038-.038-.076-.114-.152-.19a.541.541,0,0,0-.076.229h-.038a.289.289,0,0,1-.076-.152c-.038.038-.038.114-.076.19h-.114a.531.531,0,0,1,0-.419.38.38,0,0,1,.152.19c.038-.076.038-.152.076-.229a.38.38,0,0,1,.152.19c.038-.076.076-.19.114-.267h.038l.114.457Zm-.152-.267c-.076-.038-.076-.114-.152-.19-.038.076-.038.152-.076.229-.076-.038-.114-.152-.19-.19a.483.483,0,0,0-.038.229c-.038-.114-.076-.267-.114-.419.038,0,.114.114.152.152.038-.114.038-.229.076-.3.076.038.076.114.114.152l.114-.229c.076.038.114.114.19.152C210.857,196.658,210.743,196.772,210.7,196.886Zm-.114-.571c-.038.076-.038.114-.076.19-.076-.038-.076-.114-.114-.152a.91.91,0,0,0-.076.343c-.076-.076-.19-.114-.19-.229,0-.038.038-.114.038-.152.038-.038.038-.076.076-.152.038.038.076.114.152.152a1.055,1.055,0,0,1,.038-.343c.076.038.114.114.19.19a.14.14,0,0,0,.038-.114.868.868,0,0,1,.114.419C210.7,196.429,210.667,196.353,210.59,196.315Zm.076-.571a3.671,3.671,0,0,1,0-.648h.038c0,.381.038.762.038,1.143A1.125,1.125,0,0,1,210.667,195.743Zm-.762.457a1.784,1.784,0,0,1-.8-1.638,1.25,1.25,0,0,0,.8-.229l.229.114a1.272,1.272,0,0,0,.571.114A1.784,1.784,0,0,1,209.9,196.2Zm-.5-.267a.459.459,0,0,1-.19.19c-.152-.152.038-.381.038-.571A.442.442,0,0,1,209.41,195.934Zm-.3-.838h0c.076.076.038.267.038.419a1.892,1.892,0,0,1-.076.686C209.067,195.858,209.1,195.439,209.1,195.1Zm.076.952c0,.038.038.076.038.114l.19-.19a.946.946,0,0,1,.038.343c.038-.038.076-.114.152-.152.038.114.076.19.114.3-.038.114-.114.152-.19.229l-.114-.343c-.076.038-.038.152-.114.152-.038-.076-.038-.114-.076-.19-.076.038-.114.114-.19.152,0-.038.038-.076.038-.114C209.1,196.239,209.1,196.124,209.181,196.048Zm0,.3a1.267,1.267,0,0,1,.114.229c.038-.038.038-.114.114-.152a2.624,2.624,0,0,0,.114.3l.152-.152a1.354,1.354,0,0,0-.076.381c-.038-.038-.038-.152-.038-.229-.076.038-.114.152-.19.19a.542.542,0,0,1-.076-.229c-.076.038-.076.114-.152.19-.038-.114-.152-.229-.114-.381C209.1,196.467,209.143,196.391,209.181,196.353Zm-.076.571a.669.669,0,0,1,.152-.19.542.542,0,0,1,.076.229c.076-.038.114-.152.152-.19a.534.534,0,0,1,0,.419h-.114c-.038-.038-.038-.114-.076-.19-.038.038-.076.114-.114.152h-.038a.541.541,0,0,1-.076-.229c-.038.038-.076.114-.114.152a.14.14,0,0,1-.114-.038,3.539,3.539,0,0,1,.152-.5A2.369,2.369,0,0,0,209.1,196.924Zm.267.3h-.114c0-.038.038-.076.038-.114C209.333,197.115,209.333,197.191,209.371,197.229Zm-.229-.038c-.076,0-.114-.038-.152-.038,0-.076.076-.076.076-.152C209.1,197.077,209.143,197.115,209.143,197.191Zm0,.038a3.08,3.08,0,0,0,.571.038c.038.038,0,.076,0,.152a1.836,1.836,0,0,1-.457,0c0-.152-.114-.19-.114-.038-.152-.038-.381-.038-.381-.114v-.114c0-.038-.038-.038.038-.038A3.6,3.6,0,0,0,209.143,197.229Zm.076.152a.037.037,0,0,0-.038.038c-.076,0-.076-.19.038-.152Zm1.981-.229c.076,0,.114.076.114.152-.038,0-.076-.038-.114-.038Zm-.229-.038c-.076-.267-.152-.5-.229-.762.076.038.114.114.152.152,0-.648-.076-1.333-.076-2.019a.59.59,0,0,1-.3.076,1.1,1.1,0,0,1-.648-.229,1.5,1.5,0,0,1-.5.229.468.468,0,0,1-.457-.076c-.038.686-.076,1.333-.076,2.019.076-.038.114-.114.19-.152-.076.267-.152.571-.229.8-.152-.038-.343-.152-.381.114h-.3c.038,0,.038-.076.114-.152.038-1.029.076-2.019.114-3.086a.291.291,0,0,0-.19.076c0-.152.076-.3.229-.3.343-.038.61.3.952.3,0,.038-.038.038-.076.076.076,0,.19,0,.229-.038,0,.038-.038.076-.076.114a.341.341,0,0,0,.3-.152l.114.114.114-.114a.483.483,0,0,0,.343.152c0-.038-.076-.076-.076-.114a.566.566,0,0,0,.229.038c0-.038-.076-.038-.076-.076.381,0,.571-.343.952-.3.152,0,.229.114.229.3-.076-.038-.114-.076-.19-.076.038.838.076,1.867.114,2.7,0,.114-.038.267,0,.343s.152.114.19.19h-.381C211.352,197.115,211.162,197.077,210.971,197.115Z'
          transform='translate(-208 -192.81)'
          fill='#db9c00'
        />
        <g
          id='Group_26388'
          data-name='Group 26388'
          transform='translate(0.19 0)'
        >
          <path
            id='Path_142264'
            data-name='Path 142264'
            d='M229.6,225.039a1.1,1.1,0,0,1-.648-.229,1.5,1.5,0,0,1-.5.229.468.468,0,0,1-.457-.076v.152l.19.152v-.19a1.25,1.25,0,0,0,.8-.229l.229.114a1.272,1.272,0,0,0,.571.114,2.02,2.02,0,0,1-.381,1.219h.038l.038-.038h0v.076h0a.433.433,0,0,1,.114-.3h.038c0,.152.114.343.076.5h0v0l.038.038a.946.946,0,0,1-.038-.343,3.669,3.669,0,0,1,0-.648h.038c0,.343.038.724.038,1.067l.19.152c0-.61-.038-1.219-.076-1.829A.59.59,0,0,1,229.6,225.039Z'
            transform='translate(-227.238 -223.286)'
            fill='#996a00'
          />
          <path
            id='Path_142265'
            data-name='Path 142265'
            d='M215.543,195.705a4.142,4.142,0,0,0-.038-.686,10.062,10.062,0,0,0-.076-1.1.316.316,0,0,0-.3-.114c-.3.038-.571.343-.876.3a1.219,1.219,0,0,1-.19-.5v-.3a.475.475,0,0,0-.152-.419.91.91,0,0,0-.343-.076c-.038,0-.076.038-.114.076-.152-.076-.381-.114-.343.114.152-.076.3.114.3.267a1.012,1.012,0,0,1-.229.8c-.343,0-.571-.267-.876-.3-.19,0-.267.076-.3.19h0a.257.257,0,0,1,.229-.152c.343-.038.61.3.952.3,0,.038-.038.038-.076.076.076,0,.19,0,.229-.038,0,.038-.038.076-.076.114a.341.341,0,0,0,.3-.152l.114.114.114-.114a.483.483,0,0,0,.343.152c0-.038-.076-.076-.076-.114a.566.566,0,0,0,.229.038c0-.038-.076-.038-.076-.076.381,0,.571-.343.952-.3.152,0,.229.114.229.3-.076-.038-.114-.076-.19-.076.038.838.076,1.867.114,2.7v.114l.229.19A7.791,7.791,0,0,0,215.543,195.705Z'
            transform='translate(-212 -192.81)'
            fill='#996a00'
          />
          <path
            id='Path_142266'
            data-name='Path 142266'
            d='M213.714,218.524v-.114a.14.14,0,0,0-.114.038Z'
            transform='translate(-213.524 -217.191)'
            fill='#996a00'
          />
        </g>
        <path
          id='Path_142267'
          data-name='Path 142267'
          d='M214.514,219.21c-.038.99-.076,1.981-.114,2.933.076-.038.152-.152.229-.19.038-.914.076-1.676.114-2.552A1.01,1.01,0,0,0,214.514,219.21Z'
          transform='translate(-214.095 -217.953)'
          fill='#db9c00'
        />
        <path
          id='Path_142268'
          data-name='Path 142268'
          d='M216.8,219.324l.229.19V219.4a1.01,1.01,0,0,0-.229-.19Z'
          transform='translate(-216.381 -217.953)'
          fill='#996a00'
        />
        <path
          id='Path_142269'
          data-name='Path 142269'
          d='M274.629,219.21c-.038.076-.19.114-.229.19v.343c.076.686.038,1.448.076,2.171l.114.114c.038.038.076.114.114.076C274.7,221.191,274.667,220.086,274.629,219.21Z'
          transform='translate(-271.238 -217.953)'
          fill='#db9c00'
        />
        <path
          id='Path_142270'
          data-name='Path 142270'
          d='M274.629,219.21c-.038.076-.19.114-.229.19v.343c.038.61.038,1.3.076,1.981l.229.19C274.7,221.039,274.667,220.048,274.629,219.21Z'
          transform='translate(-271.238 -217.953)'
          fill='#996a00'
        />
        <path
          id='Path_142271'
          data-name='Path 142271'
          d='M220.8,226.448c.038-.076.152-.114.19-.19s0-.19,0-.3c.038-.571.076-1.257.076-1.79-.076-.038-.114-.114-.19-.152C220.876,224.81,220.838,225.648,220.8,226.448Z'
          transform='translate(-220.19 -222.524)'
          fill='#db9c00'
        />
        <path
          id='Path_142272'
          data-name='Path 142272'
          d='M222.4,224.124l.19.152v-.114c-.076-.038-.114-.114-.19-.152C222.438,224.048,222.4,224.086,222.4,224.124Z'
          transform='translate(-221.714 -222.524)'
          fill='#996a00'
        />
        <path
          id='Path_142273'
          data-name='Path 142273'
          d='M269.6,224.924c.038.686.038,1.41.076,2.1l.152.152.038.038c-.038-.8-.076-1.676-.114-2.4C269.714,224.848,269.638,224.886,269.6,224.924Z'
          transform='translate(-266.667 -223.286)'
          fill='#db9c00'
        />
        <path
          id='Path_142274'
          data-name='Path 142274'
          d='M269.752,224.01c-.038.038-.114.076-.152.152.038.648.038,1.3.076,1.943l.19.152C269.829,225.5,269.79,224.7,269.752,224.01Z'
          transform='translate(-266.667 -222.524)'
          fill='#996a00'
        />
        <path
          id='Path_142275'
          data-name='Path 142275'
          d='M232,225.839a1.816,1.816,0,0,0,.762,1.524,1.7,1.7,0,0,0,.724-1.524,1.031,1.031,0,0,1-.724-.229A1.137,1.137,0,0,1,232,225.839Z'
          transform='translate(-230.857 -224.048)'
          fill='#db9c00'
        />
        <path
          id='Path_142276'
          data-name='Path 142276'
          d='M232,225.839c0,.076.038.114.038.19l1.1.952a1.851,1.851,0,0,0,.343-1.143,1.031,1.031,0,0,1-.724-.229A1.137,1.137,0,0,1,232,225.839Z'
          transform='translate(-230.857 -224.048)'
          fill='#996a00'
        />
        <g
          id='Group_26389'
          data-name='Group 26389'
          transform='translate(0.686 4.356)'
        >
          <path
            id='Path_142277'
            data-name='Path 142277'
            d='M222.4,284.31c.038,0,.076.038.114.038,0-.076-.076-.076-.114-.038Z'
            transform='translate(-222.4 -284.285)'
            fill='#db9c00'
          />
          <path
            id='Path_142278'
            data-name='Path 142278'
            d='M271.2,284.348c.038,0,.076-.038.114-.038C271.314,284.271,271.2,284.271,271.2,284.348Z'
            transform='translate(-268.876 -284.285)'
            fill='#db9c00'
          />
          <path
            id='Path_142279'
            data-name='Path 142279'
            d='M226.552,285.648c-.038-.038-.076-.038-.152-.038A.229.229,0,0,0,226.552,285.648Z'
            transform='translate(-226.21 -285.547)'
            fill='#db9c00'
          />
          <path
            id='Path_142280'
            data-name='Path 142280'
            d='M266.4,285.648c.038,0,.152,0,.152-.038A.394.394,0,0,0,266.4,285.648Z'
            transform='translate(-264.305 -285.547)'
            fill='#db9c00'
          />
          <path
            id='Path_142281'
            data-name='Path 142281'
            d='M257.6,286.867h.152C257.752,286.791,257.638,286.791,257.6,286.867Z'
            transform='translate(-255.924 -286.69)'
            fill='#db9c00'
          />
          <path
            id='Path_142282'
            data-name='Path 142282'
            d='M235.352,287.02c-.038,0-.152-.038-.152.038C235.238,287.02,235.352,287.058,235.352,287.02Z'
            transform='translate(-234.59 -286.88)'
            fill='#db9c00'
          />
          <path
            id='Path_142283'
            data-name='Path 142283'
            d='M240.152,287.21c-.038,0-.152,0-.152.038A.229.229,0,0,0,240.152,287.21Z'
            transform='translate(-239.162 -287.071)'
            fill='#db9c00'
          />
          <path
            id='Path_142284'
            data-name='Path 142284'
            d='M252.8,287.51a.288.288,0,0,1,.152.038C252.952,287.471,252.838,287.471,252.8,287.51Z'
            transform='translate(-251.352 -287.332)'
            fill='#db9c00'
          />
        </g>
        <g
          id='Group_26390'
          data-name='Group 26390'
          transform='translate(0.61 4.571)'
        >
          <path
            id='Path_142285'
            data-name='Path 142285'
            d='M263.634,289.039c-.114,0-.076-.19-.152-.229a.14.14,0,0,0-.114.038c.114-.076.152.114.152.229-.038,0-.038-.038-.076-.038-.076,0-.076.076-.152.076,0-.038-.038-.038-.114-.038-.038-.038,0-.114-.038-.114,0,.038.038.076.038.114-.038.038-.038.038-.038.076h-.076c0-.038,0-.076-.038-.076,0,.038-.076.038-.038.076a.118.118,0,0,1,.076.038c0,.038-.038.038-.038.076.038,0,.038-.038.076-.076.076,0,.152-.038.19,0,.038,0,.038-.076.076-.076.076.076.152-.038.19-.038h.114v-.038C263.634,289,263.672,289.039,263.634,289.039Zm-.648.114c0-.038,0-.038.038-.038v.038S263.025,289.191,262.987,289.153Zm.19,0v-.076c.038,0,.038.038,0,.076Zm.114-.038h-.038C263.177,289.077,263.291,289.039,263.291,289.115Zm-.038.038a.037.037,0,0,1,.038-.038C263.291,289.153,263.253,289.191,263.253,289.153Zm.114-.038c0-.076.076-.076.114-.038C263.482,289.115,263.406,289.115,263.368,289.115Z'
            transform='translate(-260.968 -288.81)'
            fill='#f5feff'
          />
          <path
            id='Path_142286'
            data-name='Path 142286'
            d='M221.676,289.648h0c-.038-.038-.038-.038-.076-.038v.038Z'
            transform='translate(-221.562 -289.572)'
            fill='#f5feff'
          />
          <path
            id='Path_142287'
            data-name='Path 142287'
            d='M220.876,291.21H220.8c.038.038.038.038.076,0Z'
            transform='translate(-220.8 -291.096)'
            fill='#f5feff'
          />
          <path
            id='Path_142288'
            data-name='Path 142288'
            d='M253.638,292.848v-.038H253.6a.037.037,0,0,0,.038.038Z'
            transform='translate(-252.038 -292.62)'
            fill='#f5feff'
          />
          <path
            id='Path_142289'
            data-name='Path 142289'
            d='M229.143,293.077c-.038-.038-.038-.076-.076-.114.076-.038.038-.152,0-.152s-.038.038-.076.038c0,.038.038.038.038.076-.038,0-.114.038-.152,0,0-.038,0-.076-.038-.076,0,.038.038.114-.038.152.038,0,.038-.038.076-.038.038.038.114,0,.152,0,.076.038.076.152.114.114.076,0,.076-.19.038-.267C229.181,292.886,229.257,293.077,229.143,293.077Zm-.152-.152c0-.114.152,0,.038.038Z'
            transform='translate(-228.419 -292.62)'
            fill='#f5feff'
          />
          <path
            id='Path_142290'
            data-name='Path 142290'
            d='M238.861,293.039c0-.076.038-.19,0-.229C238.861,292.848,238.823,292.962,238.861,293.039Z'
            transform='translate(-237.985 -292.62)'
            fill='#f5feff'
          />
          <path
            id='Path_142291'
            data-name='Path 142291'
            d='M254.59,292.124c-.038.038.038.038,0,.076,0,.038-.038.038-.076.038-.076-.038,0-.19-.038-.229,0,.038.038.114,0,.19-.038,0-.076,0-.076.038h.229S254.667,292.124,254.59,292.124Z'
            transform='translate(-252.8 -291.858)'
            fill='#f5feff'
          />
          <path
            id='Path_142292'
            data-name='Path 142292'
            d='M253.914,294.071c0-.038-.038,0-.038,0C253.8,294.071,253.914,294.109,253.914,294.071Z'
            transform='translate(-252.276 -293.805)'
            fill='#f5feff'
          />
          <path
            id='Path_142293'
            data-name='Path 142293'
            d='M260.587,294.41c-.038.038.038.076.038.114s-.038.038-.038.076C260.625,294.6,260.663,294.448,260.587,294.41Zm.038.114a.037.037,0,0,1-.038-.038C260.587,294.448,260.625,294.486,260.625,294.524Z'
            transform='translate(-258.682 -294.143)'
            fill='#f5feff'
          />
          <path
            id='Path_142294'
            data-name='Path 142294'
            d='M275.2,294.871c.038,0,.076.038.076,0C275.238,294.871,275.2,294.833,275.2,294.871Z'
            transform='translate(-272.61 -294.567)'
            fill='#f5feff'
          />
          <path
            id='Path_142295'
            data-name='Path 142295'
            d='M240.5,295.324h-.038c0-.038,0-.076-.038-.076a.335.335,0,0,1-.267-.038c0,.038.038.076-.038.114-.038,0-.038-.076-.076-.076-.038.038.038.076.038.076,0,.038-.038.076-.076.114.038,0,.076-.076.114-.114h.229c0,.038.038.038.076.076.038,0,.038-.076.038-.076.076,0,.114,0,.152-.038C240.609,295.21,240.5,295.248,240.5,295.324Zm-.114.076c-.038,0-.038-.038-.038-.076h-.152c0-.152.152,0,.229-.076C240.457,295.324,240.419,295.362,240.381,295.4Zm.152-.076c-.038-.038.038-.076.038-.038S240.571,295.324,240.533,295.324Z'
            transform='translate(-239.086 -294.905)'
            fill='#f5feff'
          />
          <path
            id='Path_142296'
            data-name='Path 142296'
            d='M221.638,296.509v-.038s0-.038-.038,0C221.6,296.433,221.6,296.471,221.638,296.509Z'
            transform='translate(-221.562 -296.09)'
            fill='#f5feff'
          />
          <path
            id='Path_142297'
            data-name='Path 142297'
            d='M223.2,296.533c.038.038.076,0,.076-.038C223.238,296.456,223.2,296.494,223.2,296.533Z'
            transform='translate(-223.086 -296.113)'
            fill='#f5feff'
          />
          <path
            id='Path_142298'
            data-name='Path 142298'
            d='M225.387,296.73h.038C225.425,296.654,225.349,296.692,225.387,296.73Z'
            transform='translate(-225.158 -296.311)'
            fill='#f5feff'
          />
          <path
            id='Path_142299'
            data-name='Path 142299'
            d='M255.429,298.41c-.038,0-.038.076,0,.076Z'
            transform='translate(-253.752 -297.953)'
            fill='#f5feff'
          />
          <path
            id='Path_142300'
            data-name='Path 142300'
            d='M256.8,298.558a.037.037,0,0,0,.038.038C256.914,298.558,256.8,298.482,256.8,298.558Z'
            transform='translate(-255.086 -298.063)'
            fill='#f5feff'
          />
          <path
            id='Path_142301'
            data-name='Path 142301'
            d='M221.9,289.8c.076.114-.076.152-.114.076,0-.038.038-.038.038-.076-.038,0-.038.076-.038.076-.152,0-.038-.19-.038-.267h-.038a.209.209,0,0,1-.114.19c0,.076.076.076.152.114a.229.229,0,0,0,.152.038C221.9,289.877,221.981,289.8,221.9,289.8Z'
            transform='translate(-221.562 -289.572)'
            fill='#f5feff'
          />
        </g>
      </g>
    </svg>
  );
};
export default EgyptIcon;
